var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystoreWhiteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2617 16.3955L16.7207 16.2783L3.49805 23.5908C3.14572 23.7856 2.77346 23.8607 2.41602 23.8389L13.292 13.3232L16.2617 16.3955ZM12.3447 12.3437L1.08984 23.2246C0.731009 22.8566 0.5 22.3468 0.5 21.7568V2.08593C0.500087 1.51809 0.713793 1.02449 1.0498 0.660151L12.3447 12.3437ZM21.2842 10.0879C22.707 10.8749 22.7067 12.9676 21.2842 13.7549L17.6084 15.7871L14.3076 12.3408L18.3291 8.45312L21.2842 10.0879ZM2.4873 -5.06535e-06C2.82262 -0.00815599 3.16915 0.0701174 3.49805 0.251948L17.0811 7.76367L13.3652 11.3564L2.4873 -5.06535e-06Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystoreWhiteIcon);
export default __webpack_public_path__ + "static/media/playstore-white-icon.d7c96e5a364ffe0d75061661449edc4d.svg";
export { ForwardRef as ReactComponent };